var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 114,
    viewBox: "0 0 167 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9346 99.4372C78.5488 99.4372 100.935 77.1774 100.935 49.7186C100.935 22.2598 78.5488 0 50.9346 0C23.3203 0 0.93457 22.2598 0.93457 49.7186C0.93457 77.1774 23.3203 99.4372 50.9346 99.4372Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1758 36L36.8768 64.299",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.877 36.0001L65.1759 64.299",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b37e606a864251843fe324a8cc43f0e7.svg";
export { ForwardRef as ReactComponent };